<template>
  <div>
    <not-allowed
      v-if="!AllowedDisplay && datas.access !== false"
      :data="datas"
    ></not-allowed>

    <v-row no-gutters>
      <v-col>
        <div v-if="showOnlyActiveProduct" class="mb-2 text-right">
          <v-btn x-small color="secondary" @click="resetProductFilter">
            Reset produits
          </v-btn>
        </div>

        <v-expansion-panels v-model="openedPanel" :readonly="showOnlyActiveProduct">
          <v-expansion-panel
            v-for="(item, i) in productsToDisplay"
            :key="item.id ?? i"
          >
            <v-expansion-panel-header @click="onProductPanelSelected(item)">
              {{ item.libelle }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-expansion-panels>
                <v-expansion-panel v-for="(group, e) in item.options" :key="e">
                  <v-expansion-panel-header>
                    <div class="d-flex align-center w-100">
                      <span class="text-caption">
                        {{ group.element }}
                        <span v-if="group.required">(obligatoire)</span>
                      </span>
                      <span
                        class="ml-auto text-caption font-weight-medium"
                        :class="{
                          'red--text font-weight-bold': isGroupHeaderOut(item, group),
                          'green--text font-weight-bold': isGroupHeaderNonZero(item, group),
                        }"
                      >
                        {{ getGroupHeaderAmountLabel(item, group) }}
                      </span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-radio-group
                      v-if="group.typeselect == 'radio'"
                      class="dc-group"
                      v-model="selectionGroup[item.id][group.key]"
                      @change="onRadioChange(item.id, group, $event)"
                    >
                      <div
                        v-for="(option, o) in group.options"
                        :key="o"
                        class="mb-2"
                      >
                        <div class="d-flex align-center w-100">
                          <v-radio
                            x-small
                            class="text-caption dc-radio mt-0 pt-0"
                            :value="option"
                            :label="option.title"
                          ></v-radio>
                          <v-btn
                            v-if="canShowDeselect(item.id, group, option)"
                            x-small
                            icon
                            color="grey"
                            class="mr-1"
                            @click.stop="clearOptionSelection(item.id, group, option)"
                          >
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                          <span
                            class="ml-auto text-caption font-weight-medium"
                            :class="{
                              'red--text font-weight-bold': isOptionHeaderOut(item, group, option),
                              'green--text font-weight-bold': isOptionHeaderNonZero(item, group, option),
                            }"
                          >
                            {{ getOptionHeaderAmountLabel(item, group, option) }}
                          </span>
                        </div>
                        <v-text-field
                          v-if="option.isq === true && isOptionSelected(item.id, group, option)"
                          v-model.number="option.q"
                          @input="onQtyInput(item.id, group, option)"
                          class="ml-8"
                          type="number"
                          min="1"
                          dense
                          hide-details
                          label="Qt"
                          style="max-width: 80px"
                        ></v-text-field>
                        <div
                          v-if="shouldShowGridDimensionInputs(item.id, group, option)"
                          class="d-flex align-center ml-8 mt-2"
                        >
                          <v-text-field
                            :value="option.grid_axis1_value"
                            @input="onGridAxisInput(item.id, group, option, 1, $event)"
                            class="mr-2"
                            dense
                            hide-details
                            :label="getGridAxisLabel(option, 1)"
                            style="max-width: 120px"
                          ></v-text-field>
                          <v-text-field
                            :value="option.grid_axis2_value"
                            @input="onGridAxisInput(item.id, group, option, 2, $event)"
                            dense
                            hide-details
                            :label="getGridAxisLabel(option, 2)"
                            style="max-width: 120px"
                          ></v-text-field>
                          <div
                            class="ml-2 text-caption font-weight-medium d-flex align-center"
                            :class="{
                              'red--text font-weight-bold': isGridDimensionOut(item, option),
                              'green--text font-weight-bold': isGridDimensionNonZero(item, option),
                            }"
                          >
                            <v-icon
                              v-if="isGridDimensionOut(item, option)"
                              small
                              color="red"
                              class="mr-1"
                            >
                              mdi-alert
                            </v-icon>
                            {{ getGridDimensionPriceLabel(item, option) }}
                          </div>
                        </div>
                      </div>
                    </v-radio-group>

                    <div v-else-if="group.typeselect == 'select'">
                      <v-select
                        class="dc-select mb-2"
                        v-model="selectionGroup[item.id][group.key]"
                        :items="group.options"
                        item-text="title"
                        return-object
                        dense
                        hide-details
                        label="Choisir une option"
                        @change="onSelectChange(item.id, group, $event)"
                      ></v-select>
                      <div
                        v-if="selectionGroup[item.id][group.key]"
                        class="mb-2"
                      >
                        <div class="d-flex align-center w-100">
                          <span class="text-caption">{{ selectionGroup[item.id][group.key].title }}</span>
                          <v-btn
                            v-if="canShowDeselect(item.id, group, selectionGroup[item.id][group.key])"
                            x-small
                            icon
                            color="grey"
                            class="ml-1"
                            @click.stop="clearOptionSelection(item.id, group, selectionGroup[item.id][group.key])"
                          >
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                          <span
                            class="ml-auto text-caption font-weight-medium"
                            :class="{
                              'red--text font-weight-bold': isOptionHeaderOut(item, group, selectionGroup[item.id][group.key]),
                              'green--text font-weight-bold': isOptionHeaderNonZero(item, group, selectionGroup[item.id][group.key]),
                            }"
                          >
                            {{ getOptionHeaderAmountLabel(item, group, selectionGroup[item.id][group.key]) }}
                          </span>
                        </div>
                        <v-text-field
                          v-if="selectionGroup[item.id][group.key].isq === true"
                          v-model.number="selectionGroup[item.id][group.key].q"
                          @input="onQtyInput(item.id, group, selectionGroup[item.id][group.key])"
                          type="number"
                          min="1"
                          dense
                          hide-details
                          label="Qt"
                          style="max-width: 80px"
                        ></v-text-field>
                        <div
                          v-if="shouldShowGridDimensionInputs(item.id, group, selectionGroup[item.id][group.key])"
                          class="d-flex align-center mt-2"
                        >
                          <v-text-field
                            :value="selectionGroup[item.id][group.key].grid_axis1_value"
                            @input="onGridAxisInput(item.id, group, selectionGroup[item.id][group.key], 1, $event)"
                            class="mr-2"
                            dense
                            hide-details
                            :label="getGridAxisLabel(selectionGroup[item.id][group.key], 1)"
                            style="max-width: 120px"
                          ></v-text-field>
                          <v-text-field
                            :value="selectionGroup[item.id][group.key].grid_axis2_value"
                            @input="onGridAxisInput(item.id, group, selectionGroup[item.id][group.key], 2, $event)"
                            dense
                            hide-details
                            :label="getGridAxisLabel(selectionGroup[item.id][group.key], 2)"
                            style="max-width: 120px"
                          ></v-text-field>
                          <div
                            class="ml-2 text-caption font-weight-medium d-flex align-center"
                            :class="{
                              'red--text font-weight-bold': isGridDimensionOut(item, selectionGroup[item.id][group.key]),
                              'green--text font-weight-bold': isGridDimensionNonZero(item, selectionGroup[item.id][group.key]),
                            }"
                          >
                            <v-icon
                              v-if="isGridDimensionOut(item, selectionGroup[item.id][group.key])"
                              small
                              color="red"
                              class="mr-1"
                            >
                              mdi-alert
                            </v-icon>
                            {{ getGridDimensionPriceLabel(item, selectionGroup[item.id][group.key]) }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-else-if="group.typeselect == 'checkbox'">
                      <div
                        v-for="(option, o) in group.options"
                        :key="o"
                        class="mb-2"
                      >
                        <div class="d-flex align-center w-100">
                          <v-checkbox
                            v-model="selectionGroup[item.id][group.key]"
                            :value="option"
                            :label="option.title"
                            dense
                            hide-details
                            class="mt-0 pt-0 dc-check flex-grow-1"
                            @change="onCheckboxChange(item.id, group, option)"
                          ></v-checkbox>
                          <span
                            class="ml-2 text-caption font-weight-medium"
                            :class="{
                              'red--text font-weight-bold': isOptionHeaderOut(item, group, option),
                              'green--text font-weight-bold': isOptionHeaderNonZero(item, group, option),
                            }"
                          >
                            {{ getOptionHeaderAmountLabel(item, group, option) }}
                          </span>
                        </div>
                        <v-text-field
                          v-if="option.isq === true && isOptionSelected(item.id, group, option)"
                          v-model.number="option.q"
                          @input="onQtyInput(item.id, group, option)"
                          class="ml-8"
                          type="number"
                          min="1"
                          dense
                          hide-details
                          label="Qt"
                          style="max-width: 80px"
                        ></v-text-field>
                        <div
                          v-if="shouldShowGridDimensionInputs(item.id, group, option)"
                          class="d-flex align-center ml-8 mt-2"
                        >
                          <v-text-field
                            :value="option.grid_axis1_value"
                            @input="onGridAxisInput(item.id, group, option, 1, $event)"
                            class="mr-2"
                            dense
                            hide-details
                            :label="getGridAxisLabel(option, 1)"
                            style="max-width: 120px"
                          ></v-text-field>
                          <v-text-field
                            :value="option.grid_axis2_value"
                            @input="onGridAxisInput(item.id, group, option, 2, $event)"
                            dense
                            hide-details
                            :label="getGridAxisLabel(option, 2)"
                            style="max-width: 120px"
                          ></v-text-field>
                          <div
                            class="ml-2 text-caption font-weight-medium d-flex align-center"
                            :class="{
                              'red--text font-weight-bold': isGridDimensionOut(item, option),
                              'green--text font-weight-bold': isGridDimensionNonZero(item, option),
                            }"
                          >
                            <v-icon
                              v-if="isGridDimensionOut(item, option)"
                              small
                              color="red"
                              class="mr-1"
                            >
                              mdi-alert
                            </v-icon>
                            {{ getGridDimensionPriceLabel(item, option) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import { client } from "../mixins";

export default {

  mixins: [client],
  name: "ClDevConfig",
  data: function () {
    return {
      show: false,
      AllowedDisplay: true,
      // liste des produits trouvés
      list: [],
      params: {},
      datas: [],
      storedFieldsDatas: {},
      selectionGroup : {},
      initializingSelection: false,
      lastFormDimensions: { height: null, width: null },
      activeItemId: null,
      showOnlyActiveProduct: false,
      openedPanel: null,
      skipNextReceiverSync: false,
    };
  },

  computed: {
    reloadModule() {
      return this.$store.getters.listForm(this.modalKey);
    },

    productsToDisplay() {
      if (!Array.isArray(this.datas.list)) return [];
      if (!this.showOnlyActiveProduct || this.activeItemId === null) {
        return this.datas.list;
      }
      const activeProduct = this.datas.list.find((item) => item.id === this.activeItemId);
      return activeProduct ? [activeProduct] : this.datas.list;
    }
  },
  watch: {
    reloadModule: {
      handler(val) {
      const fields = val?.fields ?? {};
      this.handleFormDimensionChanges(fields);
      // Only watch fields selected in admin (fieldsselector) for API reload.
      let isModified = false;
      const changedFields = {};
      const watchedFields = this.getWatchedFields();
      watchedFields.forEach((field) => {
        if (this.storedFieldsDatas[field] != fields[field]) {
          this.params[field] = fields[field];
          changedFields[field] = { before: this.storedFieldsDatas[field], after: fields[field] };
          this.storedFieldsDatas[field] = fields[field];
          isModified = true;
        }
      });

      if (Object.keys(changedFields).length) {
        this.debugLog("Champs formulaire modifiés (watch reloadModule)", changedFields);
      }
      if (isModified) this.callAPI();
    },
      deep: true
    },

    selectionGroup: {
      handler() {
        if (this.initializingSelection) return;
        this.pushSelectionInReceiver();
      },
      deep: true
    }

  },

  methods: {
    // Log utilitaire pour suivre les mappings admin et les valeurs calculées.
    debugLog(label, payload = null) {
      if (payload === null) {
        console.log(`[devisconfig] ${label}`);
        return;
      }
      console.log(`[devisconfig] ${label}`, payload);
    },

    ensureSelectionContainer(itemId) {
      if (!this.selectionGroup[itemId]) {
        this.$set(this.selectionGroup, itemId, {});
      }
    },

    // Normalize watched field config from admin.
    normalizeWatchedFields(rawFields) {
      let fields = rawFields;
      if (typeof fields === "string") {
        try {
          fields = JSON.parse(fields);
        } catch (e) {
          fields = fields.split(",");
        }
      }
      if (!Array.isArray(fields)) return [];

      const normalized = fields.map((field) => {
        if (typeof field === "string") return field;
        if (field && typeof field === "object") {
          return field.value ?? field.cle ?? "";
        }
        return "";
      });

      return [...new Set(
        normalized
          .map((field) => String(field ?? "").trim())
          .filter((field) => field !== "")
      )];
    },

    // Return watched field keys configured in admin.
    getWatchedFields() {
      return this.normalizeWatchedFields(this.datas?.fieldsselector);
    },

    // Sync watched field cache with current form values.
    syncWatchedFields(fields = {}) {
      const nextStored = {};
      this.getWatchedFields().forEach((field) => {
        nextStored[field] = fields[field];
        this.params[field] = fields[field];
      });
      this.storedFieldsDatas = nextStored;
      this.debugLog("Champs surveilles (fieldsselector)", nextStored);
    },

    hasDimensionsChanged(nextDimensions) {
      return this.lastFormDimensions.height !== nextDimensions.height
        || this.lastFormDimensions.width !== nextDimensions.width;
    },

    handleFormDimensionChanges(fields = {}) {
      const dimensions = this.getFormDimensions(fields);
      if (!this.hasDimensionsChanged(dimensions)) return;
      const previousDimensions = {
        height: this.lastFormDimensions.height,
        width: this.lastFormDimensions.width
      };

      this.lastFormDimensions = {
        height: dimensions.height,
        width: dimensions.width
      };

      if (!this.datas || !Array.isArray(this.datas.list) || this.datas.list.length === 0) return;

      let changedCount = 0;
      const targetItem = this.getTargetItem();
      if (targetItem) {
        changedCount += this.hydrateItemGridAxesFromForm(targetItem, dimensions, previousDimensions);
      } else {
        this.datas.list.forEach((item) => {
          changedCount += this.hydrateItemGridAxesFromForm(item, dimensions, previousDimensions);
        });
      }

      if (changedCount > 0 && !this.initializingSelection) {
        this.pushSelectionInReceiver();
      }
    },

    idsMatch(a, b) {
      return String(a ?? "") === String(b ?? "");
    },

    fieldExists(fields, key) {
      return Boolean(key) && Object.prototype.hasOwnProperty.call(fields, key);
    },

    normalizeStoredArray(rawValue) {
      let value = rawValue;
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (trimmed === "") return [];
        try {
          value = JSON.parse(trimmed);
        } catch (e) {
          return [];
        }
      }
      if (Array.isArray(value)) return value;
      if (value && Array.isArray(value.reelvalue)) return value.reelvalue;
      return [];
    },

    getSavedSelectionState(formFields = {}) {
      const key = this.datas?.fieldreceptor ?? "";
      if (!key || !this.fieldExists(formFields, key)) {
        return { exists: false, list: [] };
      }
      return { exists: true, list: this.normalizeStoredArray(formFields[key]) };
    },

    getSavedItemId(formFields = {}, savedOptions = []) {
      const idKey = this.datas?.fieldreceptoritemid ?? "";
      if (idKey && this.fieldExists(formFields, idKey)) {
        const rawId = formFields[idKey];
        if (rawId !== null && rawId !== undefined && rawId !== "") return rawId;
      }

      const firstWithItem = savedOptions.find(
        (option) => option && option.item_id !== undefined && option.item_id !== null && option.item_id !== ""
      );
      return firstWithItem ? firstWithItem.item_id : null;
    },

    findItemById(itemId) {
      if (itemId === null || itemId === undefined || itemId === "") return null;
      if (!Array.isArray(this.datas.list)) return null;
      return this.datas.list.find((item) => this.idsMatch(item.id, itemId)) ?? null;
    },

    findOptionBySavedEntry(group, savedEntry) {
      if (!group || !Array.isArray(group.options) || !savedEntry || typeof savedEntry !== "object") {
        return null;
      }

      const entryKey = savedEntry.key ?? savedEntry.option_key ?? "";
      if (entryKey !== "") {
        const byKey = group.options.find((option) => this.idsMatch(option.key, entryKey));
        if (byKey) return byKey;
      }

      const entryTitle = savedEntry.title ?? "";
      if (entryTitle !== "") {
        const byTitle = group.options.find((option) => String(option.title ?? "") === String(entryTitle));
        if (byTitle) return byTitle;
      }

      return null;
    },

    applySavedDescriptionStateOnOption(option, savedEntry) {
      if (!option || !savedEntry || typeof savedEntry !== "object") return;

      const mode = this.normalizeDescriptionMode(savedEntry?.descr_mode, savedEntry);
      const hasDescriptionData = Object.prototype.hasOwnProperty.call(savedEntry, "descr")
        || Object.prototype.hasOwnProperty.call(savedEntry, "descr_custom_source")
        || Object.prototype.hasOwnProperty.call(savedEntry, "descr_effective")
        || mode === "custom";
      if (!hasDescriptionData) return;

      const state = {
        mode,
        descr: String(savedEntry?.descr ?? ""),
        descr_custom_source: mode === "custom"
          ? this.resolveCustomSourceFromExisting(
            { descr_source: String(option?.descr ?? "") },
            savedEntry
          )
          : String(savedEntry?.descr_custom_source ?? "")
      };
      this.$set(option, "_dc_saved_description_state", state);
    },

    applySavedSelectionToGroup(itemId, group, savedEntries = []) {
      const selectedOptions = [];
      savedEntries.forEach((savedEntry) => {
        const option = this.findOptionBySavedEntry(group, savedEntry);
        if (!option) return;

        if (option.isq === true) {
          const qty = this.toNumber(savedEntry?.q);
          if (qty !== null && qty > 0) this.$set(option, "q", qty);
        }
        if (Object.prototype.hasOwnProperty.call(savedEntry, "grid_axis1_value")) {
          this.$set(option, "grid_axis1_value", savedEntry.grid_axis1_value);
        }
        if (Object.prototype.hasOwnProperty.call(savedEntry, "grid_axis2_value")) {
          this.$set(option, "grid_axis2_value", savedEntry.grid_axis2_value);
        }
        if (
          String(option?.grid_axis1_label ?? "").trim() === "" &&
          String(savedEntry?.grid_axis1_label ?? "").trim() !== ""
        ) {
          this.$set(option, "grid_axis1_label", String(savedEntry.grid_axis1_label));
        }
        if (
          String(option?.grid_axis2_label ?? "").trim() === "" &&
          String(savedEntry?.grid_axis2_label ?? "").trim() !== ""
        ) {
          this.$set(option, "grid_axis2_label", String(savedEntry.grid_axis2_label));
        }
        this.hydrateGridAxesFromForm(option);
        this.applySavedDescriptionStateOnOption(option, savedEntry);

        if (!selectedOptions.includes(option)) selectedOptions.push(option);
      });

      if (group.typeselect === "checkbox") {
        this.$set(this.selectionGroup[itemId], group.key, selectedOptions);
        this.clearGroupQty(group, selectedOptions);
        return;
      }

      const selectedOption = selectedOptions[0] ?? null;
      this.$set(this.selectionGroup[itemId], group.key, selectedOption);
      this.clearGroupQty(group, selectedOption ? [selectedOption] : []);
    },

    restoreSelectionFromForm(formFields = {}) {
      const savedSelection = this.getSavedSelectionState(formFields);
      const savedOptions = savedSelection.list.filter((option) => option && typeof option === "object");
      const savedItemId = this.getSavedItemId(formFields, savedOptions);
      const targetItem = this.findItemById(savedItemId);

      if (!targetItem) {
        if (savedItemId !== null && savedItemId !== undefined && savedItemId !== "") {
          this.debugLog("Selected item id not found in datasource", savedItemId);
        }
        return false;
      }

      this.activeItemId = targetItem.id;
      // Apply same behavior as manual click: keep only active product visible.
      this.showOnlyActiveProduct = true;
      this.openedPanel = 0;

      if (!Array.isArray(targetItem.options)) return true;

      if (savedSelection.exists) {
        // Clear defaults first so reopening does not overwrite saved values.
        targetItem.options.forEach((group) => {
          if (group.typeselect === "checkbox") {
            this.$set(this.selectionGroup[targetItem.id], group.key, []);
          } else {
            this.$set(this.selectionGroup[targetItem.id], group.key, null);
          }
          this.clearGroupQty(group, []);
        });

        targetItem.options.forEach((group) => {
          const groupSavedEntries = savedOptions.filter((savedEntry) => {
            const sameItem = savedEntry?.item_id === undefined || savedEntry?.item_id === null || savedEntry?.item_id === ""
              ? true
              : this.idsMatch(savedEntry.item_id, targetItem.id);
            if (!sameItem) return false;
            if (savedEntry?.group_key) return this.idsMatch(savedEntry.group_key, group.key);
            if (savedEntry?.group_name) return String(savedEntry.group_name) === String(group.element ?? "");
            return false;
          });
          this.applySavedSelectionToGroup(targetItem.id, group, groupSavedEntries);
        });
      }

      this.debugLog("Restored saved selection", {
        itemId: targetItem.id,
        selectionFieldExists: savedSelection.exists,
        savedOptionsCount: savedOptions.length
      });
      return true;
    },

    getSelectedOptions(itemId, group) {
      const selected = this.selectionGroup[itemId]?.[group.key];
      if (group.typeselect === "checkbox") {
        return Array.isArray(selected) ? selected : [];
      }
      return selected ? [selected] : [];
    },

    setActiveItem(itemId) {
      this.activeItemId = itemId;
    },

    onProductPanelSelected(item) {
      if (!item || item.id === undefined || item.id === null) return;
      this.hydrateItemGridAxesFromForm(item);
      this.setActiveItem(item.id);
      this.showOnlyActiveProduct = true;
      this.$nextTick(() => {
        this.openedPanel = 0;
        this.pushSelectionInReceiver();
      });
    },

    resetProductFilter() {
      this.showOnlyActiveProduct = false;
      if (!Array.isArray(this.datas.list)) {
        this.openedPanel = null;
        return;
      }
      const activeIndex = this.datas.list.findIndex((item) => item.id === this.activeItemId);
      this.openedPanel = activeIndex >= 0 ? activeIndex : null;
    },

    getTargetItemId() {
      if (this.activeItemId !== null && this.activeItemId !== undefined) {
        const exists = Array.isArray(this.datas.list)
          ? this.datas.list.find((item) => item.id === this.activeItemId)
          : null;
        if (exists) return this.activeItemId;
      }
      if (Array.isArray(this.datas.list) && this.datas.list.length === 1) {
        return this.datas.list[0].id;
      }
      return null;
    },

    // Bloc ajouté : helpers de calcul pour options sélectionnées + grille H/L.
    getTargetItem() {
      const targetItemId = this.getTargetItemId();
      if (targetItemId === null || !Array.isArray(this.datas.list)) return null;
      return this.datas.list.find((item) => item.id === targetItemId) ?? null;
    },

    getSupplierValueFromItem(item) {
      if (!item || typeof item !== "object") return null;
      const configuredSource = String(this.datas?.fieldfournisseur ?? "fournisseur").trim();
      const source = configuredSource !== "" ? configuredSource : "fournisseur";
      let value = this.getPathValue(item, source);
      if (value === undefined && source.indexOf(".") === -1) {
        value = item[source];
      }
      return value === undefined ? null : value;
    },

    normalizeGridOption(option) {
      if (!option || typeof option !== "object") return;
      if (!Object.prototype.hasOwnProperty.call(option, "grid_axis1_label")) {
        this.$set(option, "grid_axis1_label", "");
      }
      if (!Object.prototype.hasOwnProperty.call(option, "grid_axis2_label")) {
        this.$set(option, "grid_axis2_label", "");
      }
      if (!Object.prototype.hasOwnProperty.call(option, "grid_axis1_value")) {
        this.$set(option, "grid_axis1_value", "");
      }
      if (!Object.prototype.hasOwnProperty.call(option, "grid_axis2_value")) {
        this.$set(option, "grid_axis2_value", "");
      }
    },

    isGridOption(option) {
      return Boolean(option) && option.patype === "grille";
    },

    getGridAxisLabel(option, axisIndex) {
      if (!this.isGridOption(option)) return "";
      const key = axisIndex === 1 ? "grid_axis1_label" : "grid_axis2_label";
      const label = String(option?.[key] ?? "").trim();
      return label !== "" ? label : `Axe ${axisIndex}`;
    },

    isOptionSelected(itemId, group, option) {
      if (!option || !group) return false;
      const selected = this.selectionGroup[itemId]?.[group.key];
      if (group.typeselect === "checkbox") {
        return Array.isArray(selected) && selected.includes(option);
      }
      return selected === option;
    },

    shouldShowGridDimensionInputs(itemId, group, option) {
      return this.isGridOption(option) && this.isOptionSelected(itemId, group, option);
    },

    canShowDeselect(itemId, group, option) {
      if (!group || group.required === true) return false;
      if (!option) return false;
      return this.isOptionSelected(itemId, group, option);
    },

    clearOptionSelection(itemId, group, option = null) {
      if (!group || group.required === true) return;
      this.setActiveItem(itemId);
      this.ensureSelectionContainer(itemId);

      if (group.typeselect === "checkbox") {
        const selected = this.getSelectedOptions(itemId, group);
        const nextSelected = option ? selected.filter((o) => o !== option) : [];
        this.$set(this.selectionGroup[itemId], group.key, nextSelected);
        this.clearGroupQty(group, nextSelected);
        return;
      }

      this.$set(this.selectionGroup[itemId], group.key, null);
      this.clearGroupQty(group, []);
    },

    onGridAxisInput(itemId, group, option, axisIndex, value) {
      if (!this.isGridOption(option)) return;
      this.setActiveItem(itemId);
      this.ensureSelectionContainer(itemId);

      const axisKey = axisIndex === 1 ? "grid_axis1_value" : "grid_axis2_value";
      this.$set(option, axisKey, value);

      if (group?.typeselect === "checkbox") {
        const selected = Array.isArray(this.selectionGroup[itemId][group.key])
          ? this.selectionGroup[itemId][group.key]
          : [];
        if (!selected.includes(option)) {
          this.$set(this.selectionGroup[itemId], group.key, [...selected, option]);
        }
        return;
      }

      this.$set(this.selectionGroup[itemId], group.key, option);
    },

    getGridDimensionPrice(item, option) {
      if (!this.isGridOption(option)) return null;
      return this.getSaleUnitPrice(item, option);
    },

    isGridDimensionOut(item, option) {
      if (!this.isGridOption(option)) return false;
      const gridPrice = this.getGridUnitPrice(item, option);
      return gridPrice === null || gridPrice === 0;
    },

    getGridDimensionPriceLabel(item, option) {
      const price = this.getGridDimensionPrice(item, option);
      const rounded = this.roundCurrency(price);
      if ((rounded === null || rounded === 0) && !this.isGridDimensionOut(item, option)) return "";
      if (rounded === null || rounded === 0) return "0.00 EUR";
      return `${this.formatCurrency(rounded)} EUR`;
    },

    isNonZeroAmount(value) {
      const numberValue = this.roundCurrency(value);
      return numberValue !== null && numberValue !== 0;
    },

    isGridDimensionNonZero(item, option) {
      if (this.isGridDimensionOut(item, option)) return false;
      return this.isNonZeroAmount(this.getGridDimensionPrice(item, option));
    },

    getOptionHeaderAmount(item, group, option) {
      if (!this.isOptionSelected(item.id, group, option)) return 0;
      const qty = this.getOptionQty(option);
      const unit = this.getSaleUnitPrice(item, option);
      return unit * qty;
    },

    getOptionHeaderAmountLabel(item, group, option) {
      const amount = this.getOptionHeaderAmount(item, group, option);
      if (!this.isNonZeroAmount(amount) && !this.isOptionHeaderOut(item, group, option)) return "";
      return `${this.formatCurrency(amount)} EUR`;
    },

    isOptionHeaderOut(item, group, option) {
      if (!this.isOptionSelected(item.id, group, option)) return false;
      return this.isGridDimensionOut(item, option);
    },

    isOptionHeaderNonZero(item, group, option) {
      if (!this.isOptionSelected(item.id, group, option)) return false;
      if (this.isOptionHeaderOut(item, group, option)) return false;
      return this.isNonZeroAmount(this.getOptionHeaderAmount(item, group, option));
    },

    getGroupHeaderAmount(item, group) {
      if (!item || !group) return 0;
      return this.getSelectedOptions(item.id, group)
        .reduce((sum, option) => sum + this.getOptionHeaderAmount(item, group, option), 0);
    },

    getGroupHeaderAmountLabel(item, group) {
      const amount = this.getGroupHeaderAmount(item, group);
      if (!this.isNonZeroAmount(amount) && !this.isGroupHeaderOut(item, group)) return "";
      return `${this.formatCurrency(amount)} EUR`;
    },

    isGroupHeaderOut(item, group) {
      if (!item || !group) return false;
      return this.getSelectedOptions(item.id, group).some((option) => this.isGridDimensionOut(item, option));
    },

    isGroupHeaderNonZero(item, group) {
      if (!item || !group) return false;
      if (this.isGroupHeaderOut(item, group)) return false;
      return this.isNonZeroAmount(this.getGroupHeaderAmount(item, group));
    },

    toNumber(value) {
      if (value === null || value === undefined || value === "") return null;
      const normalized = (typeof value === "string")
        ? value.replace(/\s/g, "").replace(/,/g, ".")
        : value;
      const parsed = Number(normalized);
      if (Number.isFinite(parsed)) return parsed;
      if (typeof normalized === "string") {
        const match = normalized.match(/-?\d+(?:\.\d+)?/);
        if (match) {
          const extracted = Number(match[0]);
          if (Number.isFinite(extracted)) return extracted;
        }
      }
      return null;
    },

    roundCurrency(value) {
      const numericValue = this.toNumber(value);
      if (numericValue === null) return null;
      return Math.round((numericValue + Number.EPSILON) * 100) / 100;
    },

    formatCurrency(value) {
      const rounded = this.roundCurrency(value);
      const normalized = rounded === null ? 0 : rounded;
      return normalized.toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    isAxisValueEmpty(value) {
      return value === null || value === undefined || String(value).trim() === "";
    },

    normalizeFieldValue(value) {
      if (value && typeof value === "object") {
        if (Object.prototype.hasOwnProperty.call(value, "reelvalue")) return value.reelvalue;
        if (Object.prototype.hasOwnProperty.call(value, "value")) return value.value;
      }
      return value;
    },

    getContextFieldValue(path, fields = null) {
      const key = String(path ?? "").trim();
      if (key === "") return null;
      const formFields = fields ?? (this.$store.getters.listForm(this.modalKey)?.fields ?? {});

      let value = this.getPathValue(formFields, key);
      if (value === undefined) value = this.getPathValue(this.params ?? {}, key);

      if (value === undefined && key.indexOf(".") === -1) {
        value = formFields[key];
      }
      if (value === undefined && key.indexOf(".") === -1) {
        value = (this.params ?? {})[key];
      }

      return value === undefined ? null : this.normalizeFieldValue(value);
    },

    getFormDimensions(fields = null) {
      const heightKey = String(this.datas?.fieldhauteur ?? "").trim();
      const widthKey = String(this.datas?.fieldlargeur ?? "").trim();

      const rawHeight = this.getContextFieldValue(heightKey, fields);
      const rawWidth = this.getContextFieldValue(widthKey, fields);
      const height = this.toNumber(rawHeight);
      const width = this.toNumber(rawWidth);
      return { height, width };
    },

    canFollowFormAxis(axisValue, previousDimension) {
      if (this.isAxisValueEmpty(axisValue)) return true;
      const axisNumber = this.toNumber(axisValue);
      if (axisNumber === null || previousDimension === null || previousDimension === undefined) return false;
      return axisNumber === previousDimension;
    },

    hydrateGridAxesFromForm(option, dimensions = null, previousDimensions = null) {
      if (!this.isGridOption(option)) return false;
      const dims = dimensions ?? this.getFormDimensions();
      const prevDims = previousDimensions ?? { height: null, width: null };
      let changed = false;

      if (
        dims.height !== null
        && this.canFollowFormAxis(option?.grid_axis1_value, prevDims.height)
        && this.toNumber(option?.grid_axis1_value) !== dims.height
      ) {
        this.$set(option, "grid_axis1_value", dims.height);
        changed = true;
      }
      if (
        dims.width !== null
        && this.canFollowFormAxis(option?.grid_axis2_value, prevDims.width)
        && this.toNumber(option?.grid_axis2_value) !== dims.width
      ) {
        this.$set(option, "grid_axis2_value", dims.width);
        changed = true;
      }

      return changed;
    },

    hydrateItemGridAxesFromForm(item, dimensions = null, previousDimensions = null) {
      if (!item || !Array.isArray(item.options)) return 0;
      const dims = dimensions ?? this.getFormDimensions();
      if (dims.height === null && dims.width === null) return 0;

      let changedCount = 0;
      item.options.forEach((group) => {
        const options = Array.isArray(group?.options) ? group.options : [];
        options.forEach((option) => {
          if (this.hydrateGridAxesFromForm(option, dims, previousDimensions)) changedCount += 1;
        });
      });
      return changedCount;
    },

    getOptionQty(option) {
      if (!option || option.isq !== true) return 1;
      const qty = this.toNumber(option.q);
      return qty !== null && qty > 0 ? qty : 1;
    },

    getPathValue(source, path) {
      if (!source || !path) return source;
      return path.split(".").reduce((acc, key) => {
        if (acc && Object.prototype.hasOwnProperty.call(acc, key)) return acc[key];
        return undefined;
      }, source);
    },

    normalizeGridCollection(rawValue) {
      let value = rawValue;
      if (typeof value === "string") {
        try {
          value = JSON.parse(value);
        } catch (e) {
          value = null;
        }
      }

      if (Array.isArray(value)) return value;
      if (value && Array.isArray(value.grilles)) return value.grilles;
      if (value && typeof value === "object" && value.prixMap) return [value];
      return [];
    },

    getGridCollection(item) {
      if (this.datas?.grille?.set !== true) return [];
      const from = this.datas?.grille?.from ?? "request";
      const path = this.datas?.grille?.path ?? "";
      const formFields = this.$store.getters.listForm(this.modalKey)?.fields ?? {};

      let rawValue = null;
      if (from === "file" && path) {
        rawValue = this.getPathValue(formFields, path);
      } else if (path) {
        rawValue = this.getPathValue(item, path);
      }

      if ((rawValue === null || rawValue === undefined) && path) {
        rawValue = formFields[path] ?? item?.[path];
      }
      if (rawValue === null || rawValue === undefined) {
        rawValue = item?.abaque ?? item?.abaques ?? null;
      }

      return this.normalizeGridCollection(rawValue);
    },

    findGridByRef(grids, ref) {
      if (!Array.isArray(grids) || !ref) return null;
      const searched = String(ref).trim();
      return grids.find((grid) => {
        if (!grid || typeof grid !== "object") return false;
        return [grid.key, grid.nom].some((candidate) => String(candidate ?? "").trim() === searched);
      }) ?? null;
    },

    findClosestAxisValue(axisValues, target) {
      const values = axisValues
        .map((v) => this.toNumber(v))
        .filter((v) => v !== null)
        .sort((a, b) => a - b);
      if (!values.length) return null;
      if (values.includes(target)) return target;
      const lower = values.filter((v) => v <= target).pop();
      if (lower !== undefined) return lower;
      return values[0];
    },

    getGridUnitPrice(item, option) {
      if (!option || option.patype !== "grille" || this.datas?.grille?.set !== true) return null;
      const axis1 = this.toNumber(option?.grid_axis1_value);
      const axis2 = this.toNumber(option?.grid_axis2_value);
      if (axis1 === null || axis2 === null) return null;

      const grid = this.findGridByRef(this.getGridCollection(item), option.grille);
      const prixMap = grid?.prixMap;
      if (!prixMap || typeof prixMap !== "object") return null;

      const targetAxis1 = this.findClosestAxisValue(Object.keys(prixMap), axis1);
      if (targetAxis1 === null) return null;
      const row = prixMap[targetAxis1] ?? prixMap[String(targetAxis1)];
      if (!row || typeof row !== "object") return null;

      const targetAxis2 = this.findClosestAxisValue(Object.keys(row), axis2);
      if (targetAxis2 === null) return null;
      return this.toNumber(row[targetAxis2] ?? row[String(targetAxis2)]);
    },

    getPurchaseUnitPrice(item, option) {
      let base = null;
      if (this.isGridOption(option)) {
        base = this.getGridUnitPrice(item, option);
        if (base === null || base === 0) return 0;
      } else {
        base = this.toNumber(option?.pua);
        if (base === null) return 0;
      }

      return base;
    },

    getSaleUnitPrice(item, option) {
      const purchase = this.getPurchaseUnitPrice(item, option);
      // For grid options, keep 0 when dimensions are out of range / no grid price.
      // For fixed options, a margin can still apply even when purchase is 0.
      if (this.isGridOption(option) && purchase === 0) return 0;
      const coef = this.toNumber(option?.coef);
      if (coef !== null) return purchase * coef;
      const marge = this.toNumber(option?.marge);
      if (marge !== null) return purchase + marge;
      return purchase;
    },

    getSelectionEntries() {
      const targetItem = this.getTargetItem();
      if (!targetItem || !Array.isArray(targetItem.options)) return [];

      const entries = [];
      targetItem.options.forEach((group) => {
        this.getSelectedOptions(targetItem.id, group).forEach((option) => {
          entries.push({ item: targetItem, group, option });
        });
      });
      return entries;
    },

    getUnitLabel(unitCode) {
      const map = {
        m2: "M2",
        m3: "M3",
        P: "Piece",
        S: "Service",
        ml: "M lineaire",
        l: "Litre"
      };
      return map[unitCode] ?? (unitCode ?? "");
    },

    applyDescriptionTokens(html, group, option) {
      const qty = this.getOptionQty(option);
      const unit = this.getUnitLabel(group?.unit ?? "");
      return String(html ?? "")
        .replace(/\{_unite_\}/g, unit)
        .replace(/\{_q_\}/g, String(qty));
    },

    applyDescriptionTokensFromOption(option, html) {
      const groupLike = { unit: option?.unit ?? "" };
      return this.applyDescriptionTokens(html, groupLike, option);
    },

    extractTemplateFromVisibleDescription(html) {
      return String(html ?? "")
        .replace(/<span[^>]*data-dc-token=["']q["'][^>]*>[\s\S]*?<\/span>/gi, "{_q_}")
        .replace(/<span[^>]*data-dc-token=["']unite["'][^>]*>[\s\S]*?<\/span>/gi, "{_unite_}");
    },

    hasDynamicMarkers(html) {
      const value = String(html ?? "");
      return /data-dc-token=["'](q|unite)["']/i.test(value) || value.includes("{_q_}") || value.includes("{_unite_}");
    },

    resolveCustomSourceFromExisting(mergedOption, existingOption) {
      const existingDescr = String(existingOption?.descr ?? "");
      const existingEffectiveDescr = String(existingOption?.descr_effective ?? "");
      let source = String(existingOption?.descr_custom_source ?? "");

      if (source !== "") return source;

      if (existingDescr !== "") {
        // Backward compatibility:
        // keep custom template even when markers are not present in visible HTML.
        source = this.extractTemplateFromVisibleDescription(existingDescr);
      }

      if (source !== "") return source;

      if (existingEffectiveDescr !== "") {
        source = this.extractTemplateFromVisibleDescription(existingEffectiveDescr);
      }

      if (source !== "") return source;
      // Last fallback: keep dynamic capability from the default option template.
      return String(mergedOption?.descr_source ?? "");
    },

    getCumulativeDescriptionFromSelection() {
      const chunks = [];
      this.getSelectionEntries().forEach(({ group, option }) => {
        const rawHtml = option?.descr ?? "";
        const parsedHtml = this.applyDescriptionTokens(rawHtml, group, option).trim();
        if (parsedHtml) chunks.push(parsedHtml);
      });
      const cumulativeHtml = chunks.join("<br>");
      this.debugLog("Description HTML cumulee pour le produit actif", cumulativeHtml);
      return cumulativeHtml;
    },

    getCumulativeDescriptionFromPayload(selectedOptions = []) {
      const chunks = [];
      selectedOptions.forEach((option) => {
        const html = String(option?.descr_effective ?? "").trim();
        if (html) chunks.push(html);
      });
      const cumulativeHtml = chunks.join("<br>");
      this.debugLog("Description HTML cumulee depuis payload", cumulativeHtml);
      return cumulativeHtml;
    },

    getTotalsFromSelection() {
      const totals = { vente: 0, achat: 0, pose: 0 };
      this.getSelectionEntries().forEach(({ item, option }) => {
        const qty = this.getOptionQty(option);
        const puv = this.getSaleUnitPrice(item, option);
        const pup = this.toNumber(option?.pup) ?? 0;
        const pua = this.getPurchaseUnitPrice(item, option);

        totals.vente += puv * qty;
        totals.achat += pua * qty;
        totals.pose += pup * qty;
      });
      totals.vente = this.roundCurrency(totals.vente) ?? 0;
      totals.achat = this.roundCurrency(totals.achat) ?? 0;
      totals.pose = this.roundCurrency(totals.pose) ?? 0;
      this.debugLog("Totaux calculés pour le produit actif", totals);
      return totals;
    },

    createReceiverInsert(key, reelvalue) {
      return {
        key,
        type: "valuefromfield",
        reelvalue,
        descr: "",
        guard: false,
        firstload: false,
        fromField: false
      };
    },

    clearGroupQty(group, selectedOptions) {
      if (!Array.isArray(group.options)) return;
      group.options.forEach((option) => {
        if (option.isq !== true) return;
        if (!selectedOptions.includes(option)) {
          this.$set(option, "q", null);
        }
      });
    },

    onQtyInput(itemId, group, option) {
      const qty = Number(option.q);
      if (option.q === null || option.q === "" || Number.isNaN(qty) || qty <= 0) {
        return;
      }

      this.setActiveItem(itemId);
      this.ensureSelectionContainer(itemId);

      if (group.typeselect === "checkbox") {
        const selected = Array.isArray(this.selectionGroup[itemId][group.key])
          ? this.selectionGroup[itemId][group.key]
          : [];
        if (!selected.includes(option)) {
          this.$set(this.selectionGroup[itemId], group.key, [...selected, option]);
        }
        return;
      }

      this.$set(this.selectionGroup[itemId], group.key, option);
      this.clearGroupQty(group, [option]);
    },

    onSelectChange(itemId, group, selectedOption) {
      this.setActiveItem(itemId);
      this.ensureSelectionContainer(itemId);
      this.hydrateGridAxesFromForm(selectedOption);
      this.$set(this.selectionGroup[itemId], group.key, selectedOption ?? null);
      const selectedOptions = selectedOption ? [selectedOption] : [];
      this.clearGroupQty(group, selectedOptions);
    },

    onRadioChange(itemId, group, selectedOption) {
      this.setActiveItem(itemId);
      this.ensureSelectionContainer(itemId);
      this.hydrateGridAxesFromForm(selectedOption);
      this.$set(this.selectionGroup[itemId], group.key, selectedOption ?? null);
      const selectedOptions = selectedOption ? [selectedOption] : [];
      this.clearGroupQty(group, selectedOptions);
    },

    onCheckboxChange(itemId, group, option) {
      this.setActiveItem(itemId);
      const selected = this.getSelectedOptions(itemId, group);
      const isSelected = selected.includes(option);

      if (!isSelected && option.isq === true) {
        this.$set(option, "q", null);
      }
      if (isSelected && option.isq === true) {
        const qty = Number(option.q);
        if (option.q === null || option.q === "" || Number.isNaN(qty) || qty <= 0) {
          this.$set(option, "q", 1);
        }
      }
      if (isSelected) {
        this.hydrateGridAxesFromForm(option);
      }
    },

    formatSelectedOption(item, group, option) {
      const cloned = JSON.parse(JSON.stringify(option));
      const savedDescriptionState = option?._dc_saved_description_state ?? null;
      if (Object.prototype.hasOwnProperty.call(cloned, "_dc_saved_description_state")) {
        delete cloned._dc_saved_description_state;
      }
      const sourceDescr = String(option?.descr ?? "");
      const dynamicOriginalDescr = this.applyDescriptionTokens(sourceDescr, group, option);
      cloned.item_id = item.id;
      cloned.item_libelle = item.libelle;
      cloned.group_key = group.key;
      cloned.group_name = group.element;
      cloned.group_type = group.typeselect;
      cloned.unit = group.unit ?? "";
      // Description system:
      // - descr_source: raw HTML template from options creator (with tokens)
      // - descr_original: dynamic HTML from options creator with tokens resolved
      // - descr_mode: active source ("original" | "custom")
      // - descr_custom_source: custom HTML template memory (with tokens)
      // - descr: custom HTML visible in editor (resolved for readability)
      cloned.descr_original = dynamicOriginalDescr;
      cloned.descr_source = sourceDescr;
      cloned.descr_mode = savedDescriptionState?.mode ?? "original";
      // "descr_custom_source" stores hidden custom template with tokens.
      cloned.descr_custom_source = String(savedDescriptionState?.descr_custom_source ?? "");
      // "descr" stores visible custom content only.
      cloned.descr = String(savedDescriptionState?.descr ?? "");
      if (cloned.descr_mode === "custom" && cloned.descr_custom_source === "" && cloned.descr !== "") {
        cloned.descr_custom_source = this.extractTemplateFromVisibleDescription(cloned.descr);
      }
      if (this.isGridOption(cloned)) {
        cloned.grid_axis1_label = String(cloned.grid_axis1_label ?? "");
        cloned.grid_axis2_label = String(cloned.grid_axis2_label ?? "");
        cloned.grid_axis1_value = cloned.grid_axis1_value ?? "";
        cloned.grid_axis2_value = cloned.grid_axis2_value ?? "";
      }
      if (!Object.prototype.hasOwnProperty.call(cloned, "tva")) {
        cloned.tva = group.tva ?? "";
      }
      return cloned;
    },

    getReceptorValue() {
      const selected = [];
      this.getSelectionEntries().forEach(({ item, group, option }) => {
        selected.push(this.formatSelectedOption(item, group, option));
      });
      return selected;
    },

    normalizeStoredOptions(rawValue) {
      let value = rawValue;
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (trimmed === "") return [];
        try {
          value = JSON.parse(trimmed);
        } catch (e) {
          return [];
        }
      }
      return Array.isArray(value) ? value : [];
    },

    getExistingReceptorOptionsFromForm(formFields = {}) {
      const receptorField = this.datas?.fieldreceptor ?? "";
      if (!receptorField) return [];
      return this.normalizeStoredOptions(formFields[receptorField]);
    },

    buildOptionSelectionKey(option) {
      const itemId = String(option?.item_id ?? "");
      const groupKey = String(option?.group_key ?? "");
      const optionKey = String(option?.key ?? option?.option_key ?? "");
      const optionTitle = String(option?.title ?? "");
      return `${itemId}|${groupKey}|${optionKey}|${optionTitle}`;
    },

    normalizeOptionMatchValue(value) {
      return String(value ?? "").trim().toLowerCase();
    },

    findExistingOptionForMerge(option, existingOptions, existingByKey) {
      const exact = existingByKey.get(this.buildOptionSelectionKey(option));
      if (exact) return exact;

      const optionTitle = this.normalizeOptionMatchValue(option?.title);
      const optionItemId = this.normalizeOptionMatchValue(option?.item_id);
      const optionGroupKey = this.normalizeOptionMatchValue(option?.group_key);
      const optionGroupName = this.normalizeOptionMatchValue(option?.group_name);

      if (optionTitle === "") return null;

      const normalizedExisting = existingOptions.map((candidate) => ({
        candidate,
        title: this.normalizeOptionMatchValue(candidate?.title),
        itemId: this.normalizeOptionMatchValue(candidate?.item_id),
        groupKey: this.normalizeOptionMatchValue(candidate?.group_key),
        groupName: this.normalizeOptionMatchValue(candidate?.group_name)
      }));

      const byTitle = normalizedExisting.filter((entry) => entry.title === optionTitle);
      if (!byTitle.length) return null;

      const byItemGroupKey = byTitle.filter(
        (entry) => optionItemId !== "" && optionGroupKey !== ""
          && entry.itemId === optionItemId
          && entry.groupKey === optionGroupKey
      );
      if (byItemGroupKey.length === 1) return byItemGroupKey[0].candidate;

      const byItemGroupName = byTitle.filter(
        (entry) => optionItemId !== "" && optionGroupName !== ""
          && entry.itemId === optionItemId
          && entry.groupName === optionGroupName
      );
      if (byItemGroupName.length === 1) return byItemGroupName[0].candidate;

      const byItem = byTitle.filter(
        (entry) => optionItemId !== ""
          && entry.itemId === optionItemId
      );
      if (byItem.length === 1) return byItem[0].candidate;

      if (byTitle.length === 1) return byTitle[0].candidate;
      return null;
    },

    normalizeDescriptionMode(rawMode, fallbackOption = null) {
      if (rawMode === "custom" || rawMode === "original") return rawMode;
      if (
        fallbackOption &&
        String(fallbackOption.descr ?? "") !== "" &&
        String(fallbackOption.descr ?? "") !== String(fallbackOption.descr_original ?? "")
      ) return "custom";
      return "original";
    },

    mergeDescriptionStateFromExisting(selectedOptions) {
      const formFields = this.$store.getters.listForm(this.modalKey)?.fields ?? {};
      const existingOptions = this.getExistingReceptorOptionsFromForm(formFields);
      if (!existingOptions.length) return selectedOptions;

      const existingByKey = new Map();
      existingOptions.forEach((option) => {
        existingByKey.set(this.buildOptionSelectionKey(option), option);
      });

      return selectedOptions.map((option) => {
        const existing = this.findExistingOptionForMerge(option, existingOptions, existingByKey);
        if (!existing) return option;

        const merged = JSON.parse(JSON.stringify(option));
        const mode = this.normalizeDescriptionMode(existing.descr_mode, existing);
        merged.descr_mode = mode;
        if (mode === "custom") {
          merged.descr_custom_source = this.resolveCustomSourceFromExisting(merged, existing);
        }
        if (Object.prototype.hasOwnProperty.call(existing, "descr")) {
          // Keep visible custom description memory whatever the active mode is.
          merged.descr = String(existing.descr ?? "");
        }
        return merged;
      });
    },

    applyActiveDescriptionMode(selectedOptions) {
      return selectedOptions.map((option) => {
        const normalized = JSON.parse(JSON.stringify(option));
        const mode = this.normalizeDescriptionMode(normalized.descr_mode, normalized);
        normalized.descr_mode = mode;
        const customSource = String(normalized.descr_custom_source ?? "");
        if (mode === "custom" && customSource === "") {
          normalized.descr_custom_source = String(normalized.descr_source ?? "");
        }
        // Effective description is exposed separately, without overwriting custom source memory.
        normalized.descr_effective = (mode === "custom")
          ? this.applyDescriptionTokensFromOption(
            normalized,
            String(normalized.descr_custom_source ?? normalized.descr_source ?? "")
          )
          : String(normalized.descr_original ?? "");
        return normalized;
      });
    },

    // Bloc ajouté : envoie les options + totaux vers les champs mappés du formulaire.
    pushSelectionInReceiver() {
      const getConditionForm = this.$store.getters.getConditionForm;
      if (typeof getConditionForm !== "function" || !getConditionForm(this.modalKey)) {
        this.debugLog("ConditionForm indisponible, aucun envoi");
        return;
      }
      if (this.skipNextReceiverSync) {
        this.debugLog("Synchronisation receptor ignoree pour preserver l etat custom sauvegarde");
        this.skipNextReceiverSync = false;
        return;
      }

      const field = {};
      const formDimensions = this.getFormDimensions();
      this.getSelectionEntries().forEach(({ option }) => {
        this.hydrateGridAxesFromForm(option, formDimensions);
      });
      const selectedOptions = this.applyActiveDescriptionMode(
        this.mergeDescriptionStateFromExisting(this.getReceptorValue())
      );
      const selectedItemId = this.getTargetItemId();
      const targetItem = this.getTargetItem();
      const supplierFieldKey = String(this.datas?.fieldreceptorfournisseur ?? "").trim();
      const selectedSupplier = targetItem
        ? this.getSupplierValueFromItem(targetItem)
        : (supplierFieldKey !== "" ? this.getContextFieldValue(supplierFieldKey) : null);
      if (this.datas?.fieldreceptoritemid) {
        // Field receiving selected product id.
        field[this.datas.fieldreceptoritemid] = {
          insert: [this.createReceiverInsert("devisconfig_selected_item_id", selectedItemId)],
          remove: []
        };
      }
      if (this.datas?.fieldreceptor) {
        // Champ récepteur principal des options sélectionnées (array).
        field[this.datas.fieldreceptor] = {
          insert: [this.createReceiverInsert("devisconfig_selection", selectedOptions)],
          remove: []
        };
      }

      const totals = this.getTotalsFromSelection();
      const cumulativeDescription = this.getCumulativeDescriptionFromPayload(selectedOptions);
      if (this.datas?.fieldreceptorvente) {
        // Champ récepteur du total prix de vente (nombre).
        field[this.datas.fieldreceptorvente] = {
          insert: [this.createReceiverInsert("devisconfig_total_vente", totals.vente)],
          remove: []
        };
      }
      if (this.datas?.fieldreceptorachat) {
        // Champ récepteur du total prix d'achat (nombre).
        field[this.datas.fieldreceptorachat] = {
          insert: [this.createReceiverInsert("devisconfig_total_achat", totals.achat)],
          remove: []
        };
      }
      if (this.datas?.fieldreceptorpose) {
        // Champ récepteur du total prix de pose (nombre).
        field[this.datas.fieldreceptorpose] = {
          insert: [this.createReceiverInsert("devisconfig_total_pose", totals.pose)],
          remove: []
        };
      }
      if (this.datas?.fieldreceptordescr) {
        // Champ récepteur de la description HTML cumulée des options.
        field[this.datas.fieldreceptordescr] = {
          insert: [this.createReceiverInsert("devisconfig_description_cumulee", cumulativeDescription)],
          remove: []
        };
      }
      if (this.datas?.fieldreceptorfournisseur) {
        field[this.datas.fieldreceptorfournisseur] = {
          insert: [this.createReceiverInsert("devisconfig_fournisseur", selectedSupplier)],
          remove: []
        };
      }

      if (!Object.keys(field).length) return;
      this.debugLog("Mappings admin actifs", {
        fieldreceptoritemid: this.datas?.fieldreceptoritemid ?? "",
        fieldreceptor: this.datas?.fieldreceptor ?? "",
        fieldreceptorvente: this.datas?.fieldreceptorvente ?? "",
        fieldreceptorachat: this.datas?.fieldreceptorachat ?? "",
        fieldreceptorpose: this.datas?.fieldreceptorpose ?? "",
        fieldreceptordescr: this.datas?.fieldreceptordescr ?? "",
        fieldreceptorfournisseur: this.datas?.fieldreceptorfournisseur ?? "",
        fieldfournisseur: this.datas?.fieldfournisseur ?? "fournisseur",
        grille: this.datas?.grille ?? {}
      });
      this.debugLog("Options sélectionnées (produit actif)", selectedOptions);
      this.debugLog("Payload envoyé vers changeConditionForm", field);
      this.$store.dispatch("changeConditionForm", { page: this.modalKey, datas: field });
    },

    callAPI: function () {
      this.API({
        type: "post",
        url: "displaymodule",
        params: {
          id: this.idmodule,
          params: this.params,
          querys: this.$route.query,
        },
      }).then((resp) => {
        this.manageDatas(resp.data);
      });
    },

    manageDatas(data) {
      this.datas = data;
      if (!data.success) {
        this.AllowedDisplay = false;
        return false;
      }
      // Trace les valeurs de mapping configurées côté admin pour debug runtime.
      this.debugLog("Configuration devisconfig reçue du backend", {
        fieldreceptoritemid: this.datas?.fieldreceptoritemid ?? "",
        fieldreceptor: this.datas?.fieldreceptor ?? "",
        fieldreceptorvente: this.datas?.fieldreceptorvente ?? "",
        fieldreceptorachat: this.datas?.fieldreceptorachat ?? "",
        fieldreceptorpose: this.datas?.fieldreceptorpose ?? "",
        fieldreceptordescr: this.datas?.fieldreceptordescr ?? "",
        fieldreceptorfournisseur: this.datas?.fieldreceptorfournisseur ?? "",
        fieldfournisseur: this.datas?.fieldfournisseur ?? "fournisseur",
        grille: this.datas?.grille ?? {}
      });

      //initialisation de la variable qui va stocker les éléments cochés pour chaque groupe d'option
      this.initializingSelection = true;
      this.selectionGroup = {}
      this.activeItemId = null;
      this.showOnlyActiveProduct = false;
      this.openedPanel = null;
      const formFields = this.$store.getters.listForm(this.modalKey)?.fields ?? {};
      const formDimensions = this.getFormDimensions(formFields);
      this.lastFormDimensions = {
        height: formDimensions.height,
        width: formDimensions.width
      };
      this.datas.list.forEach((item) => {
        this.$set(this.selectionGroup, item.id, {});
        item.options.forEach((group) => {
          const options = Array.isArray(group.options) ? group.options : [];
          options.forEach((option) => {
            this.normalizeGridOption(option);
            this.hydrateGridAxesFromForm(option, formDimensions);
          });

          if (group.typeselect === "checkbox") {
            const defaultOptions = options.filter((option) => option.default === true);
            this.$set(this.selectionGroup[item.id], group.key, defaultOptions);
            this.clearGroupQty(group, defaultOptions);
            return;
          }

          const defaultOption = options.find((option) => option.default === true) ?? null;
          this.$set(this.selectionGroup[item.id], group.key, defaultOption);
          this.clearGroupQty(group, defaultOption ? [defaultOption] : []);
        })

      })
      const savedSelectionState = this.getSavedSelectionState(formFields);
      const hasSavedOptions = savedSelectionState.exists
        && savedSelectionState.list.some((option) => option && typeof option === "object");
      const restoredSelection = this.restoreSelectionFromForm(formFields);
      this.skipNextReceiverSync = !restoredSelection && hasSavedOptions;
      if (this.skipNextReceiverSync) {
        this.debugLog("Restauration selection impossible: preservation temporaire des options sauvegardees");
      }
      if (!restoredSelection && Array.isArray(this.datas.list) && this.datas.list.length === 1) {
        this.activeItemId = this.datas.list[0].id;
        this.openedPanel = 0;
      }
      this.initializingSelection = false;
      this.pushSelectionInReceiver();
      // Refresh watched field cache after each API response.
      this.syncWatchedFields(formFields);
      this.show = true;

      //
    },
  },
  mounted() {
    //récupération des donnée primaires (id ede la ligne)
    this.params = this.$store.getters.specificPage(this.modalKey).params;
    //intégration des champs du formulaire qui va permettre au back en fonctio ndes champs écoutés, de filter la requete
    let fields = this.$store.getters.listForm(this.modalKey)?.fields ?? {};
    this.params = { ...this.params, ...fields };
    this.callAPI();
  },
};
</script>
<style scoped>
::v-deep .dc-group .v-messages,
::v-deep .dc-select .v-messages,
::v-deep .dc-check .v-messages {
  min-height: 0 !important;
}

::v-deep .dc-radio.v-input--selection-controls,
::v-deep .dc-check.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
  margin-bottom: 0 !important;
}

::v-deep .dc-select .v-input__slot {
  min-height: 28px !important;
}

::v-deep .dc-radio .v-label,
::v-deep .dc-check .v-label,
::v-deep .dc-select .v-label {
  font-size: 12px;
}

::v-deep .dc-radio .v-input--selection-controls__input,
::v-deep .dc-check .v-input--selection-controls__input {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

::v-deep .dc-radio .v-input--selection-controls__input .v-icon,
::v-deep .dc-check .v-input--selection-controls__input .v-icon {
  font-size: 16px !important;
}

::v-deep .dc-radio .v-input--selection-controls__ripple,
::v-deep .dc-check .v-input--selection-controls__ripple {
  transform: scale(0.65);
}
</style>


